// src/core/config/branding.js
//
// Client-facing brand assets and strings. Replaced per client.

export const branding = {
  name: 'DrivenBy Bus',
  tagline: 'Live Public Transit Operations & Intelligence',
  copyrightHolder: 'DrivenBy Limited',
  companyUrl: 'https://drivenby.com.hk',
  contactEmail: 'info@drivenby.com.hk',
  logoLight: '/Logo drivenby light.png',
  logoDark: '/Logo drivenby dark.png',
  corporateNotice: 'For corporate users, contact info@drivenby.com.hk directly for Enterprise Licensing.',
};